import { Component, OnInit, Input, Output, EventEmitter, ViewChild, forwardRef } from '@angular/core';
import { Browser, BrowserOpenOptions } from '@capacitor/browser';
import { 
   IonModal, IonContent, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvTagComponent, MarvItemComponent, MarvButtonComponent, MarvFieldComponent } from '@marv/components';
import { MarvModalService } from '@marv/services';
import { MissionItem, OperationLogo, OperationLogoComponent } from '@app/components';
import { environment } from '@app/environment';
import { MissionTypeService, OperationService, TokenService } from '@app/services';
import { Cra, Pcheck } from '@app/models';
import { EpochToStringPipe } from '@app/pipes';

@Component({
    selector: 'app-mission-item-history',
    templateUrl: './item-history.component.html',
    styleUrls: ['./item-history.component.scss'],
    imports: [
        IonModal, IonContent, IonIcon, TranslatePipe, 
        forwardRef(() => MarvTagComponent), forwardRef(() => MarvItemComponent), forwardRef(() => MarvButtonComponent), 
        forwardRef(() => MarvFieldComponent), forwardRef(() => EpochToStringPipe), 
        forwardRef(() => OperationLogoComponent)
    ]
})
export class MissionItemHistoryComponent  implements OnInit {

    @Input({alias : 'mission', required : true}) mission: MissionItem;
    @Input({alias : 'displayOperation', required : false}) displayOperation: boolean = true;
    @Input({alias : 'isClickable', required : false}) isClickable: boolean = true;
    @Output() onSelectMission = new EventEmitter<MissionItem>();

    @ViewChild('modalPresenceForm') modalPresenceForm: IonModal;

    pcheck: Pcheck|null = null;

    constructor(
        private marvModalService: MarvModalService,
        public missionTypeService: MissionTypeService,
        private tokenService: TokenService
    ) { }

    async ngOnInit() {
        if(this.mission.source === 'loga'){
            this.pcheck = this.mission.presenceCheck;            
            if(this.pcheck !== null && this.pcheck.formOnlineResponses !== null){
                this.pcheck.formOnlineResponses.sort((a, b) => {
                    return (a.rank > b.rank ? 1 : (a.rank < b.rank ? -1 : 0));
                });
            }
        }
    }
    
    getOperationLogo(): OperationLogo{
        return new OperationLogo(this.mission.operation.name); // A MODIFIER - Affichage du logo de l'agence par défaut (et non du logo de l'OP)
    }

    selectMission(){
        this.onSelectMission.emit(this.mission);        
    }
    
    isCraDisplayAllowed(): boolean {
        let displayCra: boolean = false;
        if(this.mission.source === 'loga'){
            let operationSettings = OperationService.OperationsSettings.get(this.mission.operation?.id);
            if (operationSettings && this.mission.report !== null) {
                if (operationSettings.showCra === "PUBLISHED") {
                    displayCra = this.mission.report.published;
                } 
                else if (operationSettings.showCra === "YES") {
                    displayCra = true;
                }
            }             
        }
        return displayCra;
    }

    async openCra($event: any){
        $event.stopPropagation();
        if(this.mission.source === 'loga' && this.mission.report !== null && this.isCraDisplayAllowed()){            
            let animaToken: string = this.tokenService.buildAnimaToken(this.mission.report.id);
            let options: BrowserOpenOptions = {
                url: environment.ANIMA_REPORTS_URL + "/" + this.mission.report.id + "/jstart.html?tkn=" + animaToken,
                presentationStyle: 'fullscreen',
                windowName: 'anima_cra'
            };
            await Browser.open(options);
        }
    }
    
    openPresenceFormModal($event: any){
        $event.stopPropagation();
        this.marvModalService.open(this.modalPresenceForm);
    }    
    
    closePresenceFormModal(){
        this.modalPresenceForm.dismiss();
    }
    
    async canDismissPresenceFormModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    onDidDismissPresenceFormModal($event: any){
        this.marvModalService.onDidDismiss($event);
    }
}
